<template>
	<div class="message__item" :class="{'message__item--error' : typeError, 'message__item--success' : typeSuccess }">
		<span class="message__icon"></span>
		<div class="message__body">
			<div class="message__title" v-if="title">{{ title }}</div>
			<div class="message__text" v-if="text">{{ text }}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "MessageItem",
	props: {
		title: {
			type: String,
			default: '',
		},
		text : {
			type: String,
			default: '',
		},
		typeError: {
			type: Boolean,
			default: false,
		},
		typeSuccess: {
			type: Boolean,
			default: false,
		}
	}
}
</script>

